import { render, staticRenderFns } from "./ForumValores.vue?vue&type=template&id=7dc2ca24&scoped=true&"
import script from "./ForumValores.vue?vue&type=script&lang=js&"
export * from "./ForumValores.vue?vue&type=script&lang=js&"
import style0 from "./ForumValores.vue?vue&type=style&index=0&id=7dc2ca24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc2ca24",
  null
  
)

export default component.exports